import{ISO_DATE_FORMAT as o}from"../../../common/utils/formatDate.js";import r from"dayjs";var t=t=>{if(!t)return null;const a=r(t);return a.isValid()?a.format(o):null};export{t as toIsoDate};
//# sourceMappingURL=toIsoDate.js.map